export const BACKEND_API_ENDPOINT = process.env.REACT_APP_BACKEND_API_ENDPOINT;
